import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import { version as pkgVersion } from '../../package.json';

export function getAppVersion(): string {
  try {
    if (Platform.OS === 'web') {
      const version: string = pkgVersion;
      return `CDS (${version})`;
    }
    const v = DeviceInfo.getVersion();
    if (!v || v === 'unknown') {
      console.warn('[getAppVersion] DeviceInfo returned unknown version');
      return 'CDS';
    }
    return `CDS (${v})`;
  } catch (e) {
    console.error('[getAppVersion] Failed to read app version', e);
    return 'CDS';
  }
}
